export const SHOP_CODE_REGEX = /^[a-zA-Z0-9-]{1,20}$/;
export const ALPHA_NUMERIC_WITH_SPECIAL_CHAR_REGEX = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?\s]*$/;
export const ALPHA_NUMERIC_REGEX = /[^a-zA-Z0-9-]/g;
export const SHOPLANDING_REDIRECTION_URL = '/myshop/edit';
export const MASTERDATA_PK_SOCIALCHANNEL = 'SOCIALCHANNEL';
